import React from "react";
import UserStore from "../stores/UserStore";
import IframeResizer from "react-iframe-resizer-super";
import connectToStores from "alt-utils/lib/connectToStores";

import WorkingIndicator from "./partials/working-indicator.jsx";
import ViewLiveVirtualButton from "./partials/view-live-virtual-button.jsx";

class GodStreams extends React.Component {
  constructor(props) {
    super(props);
  }

  static getStores() {
    return [UserStore];
  }

  static getPropsFromStores() {
    return UserStore.getState();
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  componentDidMount() {}

  getStyles() {
    return {};
  }

  render() {
    let styles = this.getStyles();

    if (!this.props.apiKey) {
      return <WorkingIndicator fullPage={true} />;
    }

    const destination = `${
      process.env.WATCH_SITE_ROOT
    }admin/analytics?data=${btoa(
      JSON.stringify({
        is_god_view: true,
        api_key: this.props.apiKey
      })
    )}`;

    return (
      <div>
        <h1>God Streams</h1>
        <ViewLiveVirtualButton
          href={process.env.WATCH_SITE_ROOT}
          label="Watch on Eventive"
          godMode={true}
          primary
          style={{ margin: "1em 0" }}
        />
        <IframeResizer
          style={{
            width: "1px",
            minWidth: "100%",
            marginTop: "1em",
            border: "none"
          }}
          src={destination}
        />
      </div>
    );
  }
}

export default connectToStores(GodStreams);



// WEBPACK FOOTER //
// ./src/app/components/god-streams.jsx